import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback } from 'react';
import { useEventTracker, verifyRole, useCurrentUser } from '@applyboard/ui-utils';
import { CreateApplicationButton } from '@applyboard/ab-application';
import { CefEvent, Platform } from "../../EventTracker";
import { StudentCheckEligibilityButton } from "./StudentCheckEligibilityButton";
import { useCefEventTracker } from "../CEF/Hooks/useCefEventTracker";
import { useIsMobile } from "../CEF/Common/useIsMobile";
export function SimplifiedCheckEligibilityButton(_ref) {
  var _currentUser$full_nam;
  var eligibility = _ref.eligibility,
    eventTrackingPrefix = _ref.eventTrackingPrefix,
    onClick = _ref.onClick,
    width = _ref.width,
    program = _ref.program,
    school = _ref.school;
  var _useCurrentUser = useCurrentUser(),
    _useCurrentUser2 = _slicedToArray(_useCurrentUser, 1),
    currentUser = _useCurrentUser2[0];
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _useCefEventTracker = useCefEventTracker(),
    trackCEFEvent = _useCefEventTracker.trackEvent;
  var isMobile = useIsMobile();
  var isStudent = verifyRole.isStudent(currentUser);
  var isVisitor = verifyRole.isVisitor(currentUser);
  var student = isStudent && currentUser !== null && currentUser !== void 0 && currentUser.id ? {
    id: currentUser.id,
    name: (_currentUser$full_nam = currentUser.full_name) !== null && _currentUser$full_nam !== void 0 ? _currentUser$full_nam : undefined
  } : null;
  var handleCEFTrack = useCallback(function (eventName) {
    trackCEFEvent(CefEvent(eventName, isMobile ? Platform.Mobile : Platform.Desktop));
  }, [trackCEFEvent, isMobile]);

  // Eligibility modal open handler (tracks and calls onClick)
  var handleOpenEligibilityModal = useCallback(function () {
    if (isVisitor) {
      window.location.assign("/register?redirect_to=".concat(encodeURIComponent(location.pathname)));
      return;
    }
    onClick();
    trackEvent({
      event: "".concat(eventTrackingPrefix, " - Clicked 'Check Student Eligibility'"),
      data: {
        outcome: 'Opened student eligibility modal (Student/Advisor Flow)',
        programId: program.id
      }
    });
  }, [trackEvent, eventTrackingPrefix, program.id, onClick, isVisitor]);

  // If not student or visitor, show CreateApplicationButton
  if (!isStudent && !isVisitor) {
    return /*#__PURE__*/React.createElement(CreateApplicationButton, {
      program: program,
      school: school,
      pageName: window.location.pathname.includes('/programs') ? 'Program' : 'School',
      buttonWidth: width !== null && width !== void 0 ? width : 'hug'
    });
  }
  return /*#__PURE__*/React.createElement(StudentCheckEligibilityButton, {
    width: width !== null && width !== void 0 ? width : 'hug',
    onTrack: handleCEFTrack,
    openModalFn: handleOpenEligibilityModal,
    program: program,
    eligibility: eligibility,
    school: school,
    student: student
  });
}